import { detectPlatform } from "@/shared/lib/platform"
import { credentialStorage } from "./credential-storage"

function parseUserId(raw: string | null): number | null {
	if (!raw) return null
	const parsed = Number(raw)
	if (!Number.isFinite(parsed)) return null
	return parsed
}

/**
 * The id a session is restored from before a JWT exists. Native keeps it in
 * SecureStorage, every other host in localStorage; Telegram persists none —
 * there the id comes from the SDK on every launch.
 */
export async function getStoredUserId(): Promise<number | null> {
	return parseUserId(await credentialStorage.get("user_id"))
}

export function setStoredUserId(userId: number): Promise<void> {
	if (detectPlatform() === "telegram") return Promise.resolve()
	return credentialStorage.set({ user_id: String(userId) })
}

export function clearStoredUserId(): Promise<void> {
	return credentialStorage.remove(["user_id"])
}
